import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppUtilityService } from './app-utility.service';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  private _displayCaptions = new BehaviorSubject<boolean>(localStorage.getItem('displayCaptions') === 'true');
  private _captionLanguage = new BehaviorSubject<string>(localStorage.getItem('captionLanguage') || 'en');
  private _videoQuality = new BehaviorSubject<string>(localStorage.getItem('videoQuality') || 'md');
  private _autoPlay = new BehaviorSubject<boolean>(localStorage.getItem('autoPlay') === 'true');
  private _fullScreenVideo = new BehaviorSubject<boolean>(localStorage.getItem('fullScreenVideo') === 'true');
  private _offlineMode = new BehaviorSubject<boolean>(!navigator.onLine);

  // Observable streams
  displayCaptions$ = this._displayCaptions.asObservable();
  captionLanguage$ = this._captionLanguage.asObservable();
  videoQuality$ = this._videoQuality.asObservable();
  autoPlay$ = this._autoPlay.asObservable();
  fullScreenVideo$ = this._fullScreenVideo.asObservable();
  offlineMode$ = this._offlineMode.asObservable();

  constructor(private appUtility: AppUtilityService) {
    this.initializeListeners();
  }

  private initializeListeners(): void {
    this.syncConnectivityState();
    localStorage.setItem('videoQuality', this._videoQuality.value);

    window.addEventListener('online', () => {
      this._offlineMode.next(false);
      this.appUtility.displayMessage({
        text: "Connectivity established, all features are now available.",
        actionText: "OK",
        duration: -1
      });
    });

    window.addEventListener('offline', () => this.setOfflineMode());
  }

  private syncConnectivityState(): void {
    if (!navigator.onLine) {
      this.setOfflineMode();
    } else {
      this._offlineMode.next(false);
    }
  }

  private setOfflineMode(): void {
    this._offlineMode.next(true);
    this.appUtility.displayMessage({
      text: "The application is running in offline mode, some features will be unavailable.",
      actionText: "OK",
      duration: -1
    });
  }

  setCaptionLanguage(language: string): void {
    this._captionLanguage.next(language);
    localStorage.setItem('captionLanguage', language);
  }

  setVideoQuality(quality: string): void {
    this._videoQuality.next(quality);
    localStorage.setItem('videoQuality', quality);
  }

  toggleAutoPlay(): void {
    const newValue = !this._autoPlay.value;
    this._autoPlay.next(newValue);
    localStorage.setItem('autoPlay', newValue.toString());
  }

  toggleFullScreenVideo(): void {
    const newValue = !this._fullScreenVideo.value;
    this._fullScreenVideo.next(newValue);
    localStorage.setItem('fullScreenVideo', newValue.toString());
  }

  toggleDisplayCaptions(newValue: boolean): void {
    this._displayCaptions.next(newValue);
    localStorage.setItem('displayCaptions', newValue.toString());
  }
  
  downloadHd(): boolean {
    const userAgent = window.navigator.userAgent;
    const downloadHd = /Edge|chrome/i.test(userAgent);
    return downloadHd;
  }
}